import { render, staticRenderFns } from "./LabourRateListHandler.vue?vue&type=template&id=2ddbd9a0"
import script from "./LabourRateListHandler.vue?vue&type=script&lang=ts"
export * from "./LabourRateListHandler.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports